<div class="dialog">
  <div class="dialog-main" mat-dialog-content>
    <div class="notification-title">
      {{title}}
      <hr class="seperator">
    </div>
    <div class="content" [innerHtml]="description" >
    </div>
    <div class="ending">Thank you for your patience.</div>
  </div>
  <button mat-flat-button color="primary" class="button" mat-dialog-close="">Close</button>
</div>
